import * as Breadcrumbs from "./breadcrumbs";
import * as Intercom from "./intercom";
import * as Nav from "./nav";
import * as NavigationKeyboard from "./navigation_keyboard";
import "./notifications";
import * as Search from "./search";

export async function init() {
  const idleCallback = "requestIdleCallback" in window ? window.requestIdleCallback : window.setTimeout;

  idleCallback(() => {
    Breadcrumbs.init();
    Nav.init();
    NavigationKeyboard.init();
    Intercom.init();
    Search.init();
  });
}
